import { render, staticRenderFns } from "./entity-child-layout.vue?vue&type=template&id=68ef045c&"
import script from "./entity-child-layout.vue?vue&type=script&lang=ts&"
export * from "./entity-child-layout.vue?vue&type=script&lang=ts&"
import style0 from "./entity-child-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports